(function(angular){
	'use strict';
	
	angular
		.module('twoFactorAuthModule')
		.factory('TwoFactorAuthFactory', [
			'$q',
			'HTTP_STATUS',
			'urlFactory',
			TwoFactorAuthFactoryFunction
		]);
	
	function TwoFactorAuthFactoryFunction(
		$q,
		HTTP_STATUS,
		urlFactory
	) {
		var factory = {
			requestQrCode: requestQrCode,
			verifyEnrollmentCode: verifyEnrollmentCode
		};

		return factory;

		function requestQrCode() {
			return urlFactory.apiGetPromise('/api-secured/two-factor-auth/totp/enrollment/start')
				.then(function(response) {
					return response.data;
				});
		}

		function verifyEnrollmentCode(type, form) {
			var url = '/api-secured/two-factor-auth/' + type + '/enrollment/verify';
			var authCode = form.authCode.$viewValue;
			var data = { 'authCode': authCode};

			return urlFactory.apiPostPromise(url, data)
				.then(function() {
					return urlFactory.redirect('/account/security/two-factor-authentication/success');
				})
				.catch(function(response){
					if(response.status === HTTP_STATUS.CONFLICT) {
						return urlFactory.redirect('/account/security/two-factor-authentication/already-enabled-failure');
					}
					urlFactory.handleServerValidation(form, response);
					return $q.reject();
				});
		}
	}
})(window.angular);